import { Spinner } from 'react-bootstrap'

export default function Loader(props) {
  return (
    <div className={`d-flex justify-content-center ${props?.customClasses}`}>
      <Spinner animation="border" variant="secondary" />
    </div>
  )
}
